import React from 'react';
import { CheckCircle, Clock, AlertCircle, Calendar, Users } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Tasks() {
  const tasks = [{
    id: 1,
    title: 'Review Q3 financial reports',
    committee: 'Finance Committee',
    assignedTo: 'Mohammed Al Hashimi',
    deadline: '2023-09-15',
    status: 'completed'
  }, {
    id: 2,
    title: 'Update employee onboarding documentation',
    committee: 'HR Committee',
    assignedTo: 'Aisha Al Mansoori',
    deadline: '2023-09-20',
    status: 'pending'
  }, {
    id: 3,
    title: 'Implement new security protocols',
    committee: 'IT Committee',
    assignedTo: 'Omar Al Shamsi',
    deadline: '2023-09-10',
    status: 'delayed'
  }, {
    id: 4,
    title: 'Finalize vendor contracts',
    committee: 'Procurement Committee',
    assignedTo: 'Fatima Al Zaabi',
    deadline: '2023-09-25',
    status: 'pending'
  }, {
    id: 5,
    title: 'Conduct quality audit',
    committee: 'Quality Assurance Committee',
    assignedTo: 'Ahmed Al Dhaheri',
    deadline: '2023-09-05',
    status: 'completed'
  }];
  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'completed':
        return <CheckCircle size={16} className="text-green-500" data-id="element-2175" />;
      case 'pending':
        return <Clock size={16} className="text-orange-500" data-id="element-2176" />;
      case 'delayed':
        return <AlertCircle size={16} className="text-red-500" data-id="element-2177" />;
      default:
        return null;
    }
  };
  const getStatusText = (status: string) => {
    switch (status) {
      case 'completed':
        return 'Completed';
      case 'pending':
        return 'Pending';
      case 'delayed':
        return 'Delayed';
      default:
        return status;
    }
  };
  const getStatusClass = (status: string) => {
    switch (status) {
      case 'completed':
        return 'bg-green-100 text-green-800';
      case 'pending':
        return 'bg-orange-100 text-orange-800';
      case 'delayed':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  return <div data-id="element-2178">
      <div className="flex justify-between items-center mb-6" data-id="element-2179">
        <h1 className="text-2xl font-bold" data-id="element-2180">Tasks & Recommendations</h1>
        <Link to="/tasks/add" className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors" data-id="element-2181">
          Add New Task
        </Link>
      </div>
      <div className="bg-white rounded-lg shadow-sm mb-6 p-4" data-id="element-2182">
        <div className="flex items-center space-x-4" data-id="element-2183">
          <button className="px-4 py-2 bg-orange-500 text-white rounded-md" data-id="element-2184">
            All Tasks
          </button>
          <button className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md" data-id="element-2185">
            Assigned to Me
          </button>
          <button className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md" data-id="element-2186">
            Completed
          </button>
          <button className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md" data-id="element-2187">
            Pending
          </button>
          <button className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md" data-id="element-2188">
            Delayed
          </button>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-2189">
        <div className="overflow-x-auto" data-id="element-2190">
          <table className="w-full" data-id="element-2191">
            <thead data-id="element-2192">
              <tr className="bg-gray-50" data-id="element-2193">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2194">
                  Task
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2195">
                  Committee
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2196">
                  Assigned To
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2197">
                  Deadline
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2198">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2199">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-2200">
              {tasks.map(task => <tr key={task.id} data-id="element-2201">
                  <td className="px-6 py-4" data-id="element-2202">
                    <div className="font-medium text-gray-900" data-id="element-2203">
                      {task.title}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-2204">
                    <div className="flex items-center" data-id="element-2205">
                      <Users size={16} className="text-gray-500 mr-2" data-id="element-2206" />
                      <span data-id="element-2207">{task.committee}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-2208">
                    {task.assignedTo}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-2209">
                    <div className="flex items-center" data-id="element-2210">
                      <Calendar size={16} className="text-gray-500 mr-2" data-id="element-2211" />
                      <span data-id="element-2212">{task.deadline}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-2213">
                    <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full items-center ${getStatusClass(task.status)}`} data-id="element-2214">
                      {getStatusIcon(task.status)}
                      <span className="ml-1" data-id="element-2215">{getStatusText(task.status)}</span>
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-2216">
                    <Link to={`/tasks/${task.id}`} className="text-orange-500 hover:text-orange-700 mr-3" data-id="element-2217">
                      View
                    </Link>
                    <Link to={`/tasks/${task.id}/edit`} className="text-orange-500 hover:text-orange-700" data-id="element-2218">
                      Edit
                    </Link>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}